import { render, staticRenderFns } from "./FAQList.vue?vue&type=template&id=52bad36c&"
import script from "./FAQList.vue?vue&type=script&lang=ts&"
export * from "./FAQList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports